import React, { useEffect, useState, useRef } from 'react';
import {
  Wrapper,
  Menu,
  Button,
  MenuItem,
  openMenu,
} from 'react-aria-menubutton';
import styled from 'styled-components/macro';
import { responsive, level } from '../../../resources/constantes.json';
import RoundButtonArrow from '../../../components/Arrows/RoundButtonArrow';

const Dropdown = ({
  items,
  defaultButtonText,
  className = '',
  defaultSelectedId,
  hasSelectedItem,
  setLocalMesa,
  level: childLevel,
  openOnMount,
  selectedMesa,
  onSelection = () => {},
}) => {
  const copyItems = [...items];
  if (copyItems?.length > 0 && Number(copyItems[0].l) === level.municipio) {
    copyItems.sort((a, b) => a.c.localeCompare(b.c));
  }
  const [isOpen, setIsOpen] = useState(openOnMount);
  const [selectedId, setSelectedId] = useState(defaultSelectedId);

  const wrapperId = `menu-wrapper-level-${copyItems[0].i}`;

  //lo del isMountedRef: openMenu es asíncrono. Si desmontamos el dropdown entre que lo llamamos y lo hace da error.
  const isMountedRef = useRef(true);
  useEffect(() => {
    if (isMountedRef.current) {
      openOnMount && openMenu(wrapperId, { focusMenu: false });
    }
    return () => (isMountedRef.current = false);
  }, [openOnMount, wrapperId]);
  const item =
    hasSelectedItem && selectedId && copyItems.find(x => x.i === selectedId);
  const texto = item ? item.n : defaultButtonText;

  const setMesaFunc = codigo => {
    setLocalMesa(codigo);
  };

  return (
    <Wrapper
      onSelection={id => {
        if (childLevel <= 6) {
          setMesaFunc(null);
          setSelectedId(id.i);
        } else if (id.c.length > 11) {
          setMesaFunc(id.c);
          setSelectedId(id.c);
        }
        onSelection(id.i);
      }}
      closeOnSelection={copyItems[0]?.h?.length > 0}
      className={className}
      closeOnBlur={false}
      id={wrapperId}
      onMenuToggle={({ isOpen }) => setIsOpen(isOpen)}
    >
      <StyledButton>
        <span>{texto}</span>
        <RoundButtonArrow variant={isOpen ? 'up' : 'down'} />
      </StyledButton>
      <Menu>
        <Ul>
          {copyItems.map(ambito => (
            <li key={ambito.i + ambito.c}>
              <SMenuItem value={ambito}>
                <span
                  selected={
                    selectedMesa
                      ? selectedMesa === ambito.c
                      : selectedId === ambito.i
                  }
                  css={`
                    font-weight: ${({ selected }) =>
                      selected ? 'bold' : '400'};
                    font-size: 14px;
                  `}
                >
                  {ambito.n}
                </span>
              </SMenuItem>
            </li>
          ))}
        </Ul>
      </Menu>
    </Wrapper>
  );
};
export default Dropdown;

const StyledButton = styled(Button)`
  font-weight: bold;
  font-size: 1.6rem;
  text-transform: uppercase;
  padding: 20px 0;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  user-select: none;
  &.focus-visible {
    text-decoration: underline !important;
    outline: none !important;
  }
`;
const Ul = styled.ul`
  max-height: 260px;
  overflow: auto;
  background: white;
  margin-bottom: 20px;

  li:nth-child(odd) {
    background: white;
  }
  li:nth-child(even) {
    background: #f5f8fd;
  }

  li:hover,
  li:focus,
  li:active {
    font-weight: bold;
    background: rgb(0, 0, 0, 0.1);
  }
`;

const SMenuItem = styled(MenuItem)`
  cursor: pointer;
  padding: 1rem;
  @media (max-width: ${responsive.maxWidth.mobile}px) {
    font-size: 1.2rem;
    grid-template-columns: repeat(1, 1fr);
  }

  &.focus-visible {
    text-decoration: underline !important;
    outline: none !important;
  }
`;
